module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"nothing_found":"Nothing here."},"pt-BR":{"nothing_found":"Nada encontrado."}}')
  delete Component.options._Ctor
}
